import { useRef, useEffect } from 'react';

export function useScrollManagement({
  messages,
  currentSessionId
}) {
  const messagesEndRef = useRef(null);
  const mainContentRef = useRef(null);
  const nearBottomRef = useRef(true);

  useEffect(() => {
    const el = mainContentRef.current;
    if (!el) return;
    const onScroll = () => {
      const near = el.scrollTop + el.clientHeight >= el.scrollHeight - 200;
      nearBottomRef.current = near;
    };
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const el = mainContentRef.current;
    if (!el) return;
    if (nearBottomRef.current) {
      requestAnimationFrame(() => {
        el.scrollTop = el.scrollHeight;
      });
    }
  }, [messages]);

  useEffect(() => {
    nearBottomRef.current = true;
    requestAnimationFrame(() => {
      if (mainContentRef.current) {
        mainContentRef.current.scrollTop = mainContentRef.current.scrollHeight;
      }
    });
  }, [currentSessionId]);

  return {
    messagesEndRef,
    mainContentRef,
    nearBottomRef
  };
}
